<div class="document-name-container">
  <div class="document-name">
    <div class="headline-6">{{ documentName }}</div>
    @if (fileName) {
      <div class="file-name body-1">
        {{ fileName }}
      </div>
    }
  </div>

  @if (menu && menu.length > 0) {
    <oui-menu [menuItems]="menu" horizontalPosition="right">
      <oui-button type="icon" color="secondary">
        <oui-icon>more_vert</oui-icon>
      </oui-button>
    </oui-menu>
  }

  @if (showCloseButton) {
    <oui-button type="icon" color="secondary" (click)="close.emit()">
      <oui-icon>close</oui-icon>
    </oui-button>
  }
</div>

<ng-content></ng-content>

@if (dateAjout) {
  <div class="document-date">
    Ajouté le
    {{ dateAjout | date : 'dd/MM/yyyy à HH:mm' }}
  </div>
}
